import styled from "@emotion/styled";
import { ThemeStyle } from "assets/scss/common/theme";


export const SavedPaymentWrapper = styled.div`
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: ${({ theme }: ThemeStyle) => theme.sectionSpacingY};

  &.hidden-layer {
    display: none;
    opacity: 0;
    transition: display 0s linear 0.33s, opacity 0.33s linear;
  }
`;

export const SectionTitleWrapper = styled.div<{ theme: Theme }>`
  margin-bottom: ${({ theme }) => theme.sectionTitleSpacingBottom};
`;
